import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    SelectFilterModel,
} from '@ui/shared/util-filter';
import { CultureCategoryOrderingEnum, CultureMapService } from '@ui/shared/util-api';
import { CultureMapFilterKey } from '../../enums/culture-map-filter-key';
import { toDataResult, ToResult } from '@team23/ts-result';

@Injectable({ providedIn: 'root' })
export class CategorySelectFilterConfigService extends FilterConfigService<CultureMapFilterKey, CultureMapService> {

    constructor() {
        super(
            new SelectFilterModel(CultureMapFilterKey.Categories, 'Kulturkategorie', []),
            inject(CultureMapService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllCultureCategories({
            order: [CultureCategoryOrderingEnum.Name],
        })
            .pipe(
                map(result =>
                    result.data
                        .map(category => ({
                            value: category.id,
                            label: category.name,
                        })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
